import { useEffect } from 'react';
import { useCustomFunctions } from '../../hooks/useCustomFunctions';

const FunctionExposer = ({ onReady }) => {
  const functions = useCustomFunctions();

  const dispatchEventToHost = (eventName, detail) => {
    const event = new CustomEvent(eventName, { detail });
    window.dispatchEvent(event);
  };

  useEffect(() => {
    window.GOSApp = { ...functions, dispatchEventToHost };
    if (onReady) {
      onReady(functions);
    }
  }, [functions, onReady]);

  return null;
};

export default FunctionExposer;
